import { Component, inject, Input, OnInit, computed, Signal} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AbsoluteMediaUriService } from '../../../services/absolute-media-uri.service';
import { faChevronRight , faChevronLeft, faCreditCard, faHand, faComment} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BidderCommunityMenuService } from '../../../services/bidder-community/bidder-community-menu/bidder-community-menu.service';
import { IBidderCommunityPageData } from '../../../models/IBidderCommunityPageData';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CommonModule } from '@angular/common';
import { CreditCardsComponent } from '../credit-cards/credit-cards.component';
import { ButtonModule } from 'primeng/button';
import { CustomBreadcrumbComponent } from '../custom-breadcrumb/custom-breadcrumb.component';
import { CustomBreadcrumbService } from '../../../services/custom-breadcrumb/custom-breadcrumb.service';
import { ICustomMenuItem } from '../../../models/ICustomMenuItem';


@Component({
  selector: 'app-bidder-navigation',
  imports: [RouterOutlet, FontAwesomeModule, CommonModule, ButtonModule, CustomBreadcrumbComponent],
  templateUrl: './bidder-navigation.component.html',
  styleUrl: './bidder-navigation.component.scss'
})

export class BidderNavigationComponent implements OnInit{
  public faChevronRight = faChevronRight;  
  public faChevronLeft = faChevronLeft;  
  public faCreditCard = faCreditCard; 
  public faHand = faHand; 
  public faComment = faComment; 
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly customBreadcrumbService = inject(CustomBreadcrumbService);
  @Input() id: number | null = null;
  pageData: IBidderCommunityPageData | null = null;
  myAccountRoute:string = 'my-account';
  creditCardComponentRef: CreditCardsComponent | undefined;

  items: ICustomMenuItem[] | undefined;
  
  constructor( private bidderComunityMenuService: BidderCommunityMenuService, private router: Router){}

  isAuthenticated = computed(() => {
    return this.oidcSecurityService.authenticated().isAuthenticated;
  });

  userName: Signal<string> = computed(() => {
    if (this.isAuthenticated()) {
      const userData = this.oidcSecurityService.userData();
      if (userData.userData != null && userData.userData.name != undefined) {
        return userData.userData.name
      }
    }
    return "";
  });

  email: Signal<string> = computed(() => {
    if (this.isAuthenticated()) {
      const userData = this.oidcSecurityService.userData();
      if (userData.userData != null && userData.userData.email != undefined) {
        return userData.userData.email
      }
    }
    return "";
  });

  initials = computed(() => {
    return this.userName()
      .split(' ')
      .map((n: string) => n[0])
      .join('')
      .substring(0,2)
      .toUpperCase();
  });

  ngOnInit(): void {
    setTimeout(() => {
      this.bidderComunityMenuService.pageData$.subscribe(pageData => {
        if(pageData != null){
          this.pageData = pageData!;
          this.id = pageData.id;
          this.items = [
            { label: 'BiddingForGood' , url: this.absoluteMediaUriService.getAbsoluteMediaUri('/auction/biddingforgood.action')},
            { label: 'My Account' , url: '/my-account'},
          ];
          if(this.pageData?.pageRoute != this.myAccountRoute && this.pageData?.pageRoute != ''){
            this.items.push({ label: this.pageData!.pageName, url: '/my-account/'+this.pageData!.pageRoute},);
          }
          this.customBreadcrumbService.setItems(this.items);
        }
      })
    });
  }

  onActivate(componentRef: any): void {
    this.creditCardComponentRef = componentRef;
  }

  onBackMobile(): void{
    if (this.creditCardComponentRef) {
      this.creditCardComponentRef.onBackMobile(); 
    }
  }

  openAddCreditCardModal(): void{
    if (this.creditCardComponentRef) {
      this.creditCardComponentRef.openAddCreditCardModal(); 
    }
  }

  isCreditCardPage(){
    return this.pageData?.pageName == 'Credit Cards'
  }

  isCreditCardEditPage(){
    return this.pageData?.pageName == 'Edit Card'
  }
  isCreditCardAddPage(){
    return this.pageData?.pageName == 'Add New Card'
  }
  isCreditCardInfoPage(){
    return this.pageData?.pageName == 'Card Info'
  }

  onChevronLeftClick(){
    if(this.isCreditCardInfoPage() && this.creditCardComponentRef) {
      this.creditCardComponentRef.onBackMobile();
    }else if((this.isCreditCardEditPage()||this.isCreditCardAddPage()) && this.creditCardComponentRef) {
      this.creditCardComponentRef.turnEditMode({isWeb: false, value: false});
    }else{
      this.router.navigate(['/'+this.myAccountRoute ]);
    }
  }
}
